var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { MS_ADAPTER_ENDPOINTS } from "../../../../utils/endpoints";
import { MEETING_ROUTES } from "../../../../constants/routes";
import apiClientServices, { setAuthorization, setAuthorizationProctoring, } from "../../../../api-client";
import { messages } from "../../../../submodules/Inventory-Module-Types/src";
import { decryptText } from "../../../../utils/encrypt-decrypt";
import { useApplicationContext } from "../../../../context/application-context";
import { applyManagerLoginToContext } from "../../../../utils/manager-login-profile";
const ManagerMsLoginCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setUser } = useApplicationContext();
    const [error, setError] = useState(null);
    const [status, setStatus] = useState("Processing...");
    const [isLoading, setIsLoading] = useState(false);
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    // Function to form CreateUserCommand from MS user profile
    const formCreateUserCommand = (payload) => {
        const createUserCommand = {
            email: payload.mail,
            familyName: payload.surname || "",
            givenName: payload.givenName || "",
            name: payload.displayName || payload.mail,
            googleId: payload.id, // Using msUserId as googleId field
        };
        return createUserCommand;
    };
    // Function to decrypt and extract meeting data from link parameter
    const decryptMeetingData = (link) => {
        try {
            if (!link) {
                return null;
            }
            // Replace spaces with + (URL encoding)
            const processedLink = link.replaceAll(" ", "+");
            // Decrypt the link using the encryption key
            const encryptionKey = process.env.REACT_APP_PUBLIC_FEEDBACK_BIG;
            if (!encryptionKey) {
                console.error("Encryption key not found in environment variables");
                return null;
            }
            const stringPayload = decryptText(processedLink, encryptionKey);
            if (!stringPayload) {
                console.error("Failed to decrypt link");
                return null;
            }
            const jsonPayload = JSON.parse(stringPayload);
            console.log("jsonPayload in decryptMeetingData:", jsonPayload);
            return jsonPayload;
        }
        catch (error) {
            console.error("Error decrypting meeting data:", error);
            return null;
        }
    };
    // Function to get login URL based on environment
    const getLoginUrl = () => {
        return "/connect/login";
    };
    // Function to post user API
    const postUserApi = (createUserCommand, decryptedMeetingData, tenantId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const requestData = {
                channelType: "Google",
                profileObj: createUserCommand,
            };
            // Include decrypted meeting data if available
            if (decryptedMeetingData) {
                requestData.meetingData = decryptedMeetingData;
            }
            if (tenantId) {
                requestData.tenantId = tenantId;
            }
            const response = yield apiClientServices({
                method: "POST",
                url: getLoginUrl(),
                data: requestData,
                headers: Object.assign(Object.assign({}, apiClientServices.defaults.headers.common), (tenantId && { tid: tenantId })),
            });
            return responseHandler(response, true);
        }
        catch (err) {
            setIsLoading(false);
            message.error("Login credentials are invalid", 4);
            console.error(err);
            throw err;
        }
    });
    // Simplified response handler - only stores user_id and token in sessionStorage
    const responseHandler = (response, isGoogleSignIn) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const responseLocal = (_a = response.data) === null || _a === void 0 ? void 0 : _a.result;
        if ((responseLocal === null || responseLocal === void 0 ? void 0 : responseLocal.access_token) && (responseLocal === null || responseLocal === void 0 ? void 0 : responseLocal.user_id)) {
            // Store only user_id and token in sessionStorage
            sessionStorage.setItem("token", responseLocal.access_token);
            sessionStorage.setItem("userId", responseLocal.user_id.toString());
            sessionStorage.setItem(messages.SESSION_INTERVIEW_META_DATA, JSON.stringify({
                token: responseLocal.access_token,
                userId: responseLocal.user_id.toString(),
                app: responseLocal.tenant.assessmentLink,
            }));
            setAuthorization(responseLocal.access_token);
            setAuthorizationProctoring(responseLocal.access_token);
            applyManagerLoginToContext(responseLocal, setUser);
            setIsLoading(false);
            return true;
        }
        else if (((_b = response.data) === null || _b === void 0 ? void 0 : _b.status) === 600) {
            setIsLoading(false);
            message.error(response.data.message, 4);
            return false;
        }
        else {
            setIsLoading(false);
            message.error("Please check your email inbox for email verification and next steps.", 4);
            return false;
        }
    });
    // Function to handle MS login - forms payload and calls API
    const onMSLogin = (payload, decryptedMeetingData, tenantId) => __awaiter(void 0, void 0, void 0, function* () {
        const createUserCommand = formCreateUserCommand(payload);
        yield postUserApi(createUserCommand, decryptedMeetingData, tenantId);
    });
    useEffect(() => {
        const handleCallback = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            try {
                // Extract code from URL query params
                const code = searchParams.get("code");
                if (!code) {
                    setError("Authorization code not found in URL");
                    return;
                }
                // Get encrypted link parameter from query params or sessionStorage
                const linkParam = searchParams.get("link") ||
                    sessionStorage.getItem("manager_meeting_link_param");
                // Decrypt meeting data from link parameter
                const decryptedMeetingData = decryptMeetingData(linkParam);
                console.log("decryptedMeetingData in handlerCallback:", decryptedMeetingData);
                // Get tenantUrl from sessionStorage (stored during login init)
                const tenantUrl = sessionStorage.getItem("manager_ms_tenant_url") ||
                    window.location.origin;
                const tenantId = decryptedMeetingData === null || decryptedMeetingData === void 0 ? void 0 : decryptedMeetingData.tenantId;
                if (!tenantId) {
                    setError("Tenant not found!");
                    return;
                }
                setStatus("Exchanging authorization code for token...");
                // Call API to exchange code for token
                const response = yield axios.post(MS_ADAPTER_ENDPOINTS.EXCHANGE_CODE_AND_ACS_TOKEN, {
                    code: code,
                    tenantUrl: tenantUrl + "/manager-ms-login-callback",
                });
                if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.token) && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.msUserId)) {
                    const emailParam = searchParams.get("email");
                    const loginEmail = emailParam && isValidEmail(emailParam)
                        ? emailParam
                        : response.data.email;
                    if (!loginEmail) {
                        setError("Email not found in query params or token response");
                        return;
                    }
                    // Store token and msUserId in sessionStorage for meeting
                    sessionStorage.setItem("manager_ms_token", response.data.token);
                    sessionStorage.setItem("manager_ms_user_id", response.data.msUserId);
                    sessionStorage.setItem("manager_ms_email", loginEmail);
                    sessionStorage.setItem("manager_ms_acs_user_id", response.data.acsUserId || "");
                    // Clean up tenantUrl from sessionStorage
                    sessionStorage.removeItem("manager_ms_tenant_url");
                    setStatus("Creating user session...");
                    // Form MS user profile from API response
                    const msUserProfile = {
                        mail: loginEmail,
                        id: response.data.msUserId,
                        displayName: loginEmail.split("@")[0],
                        givenName: loginEmail.split("@")[0],
                        surname: "",
                    };
                    // Call onMSLogin to create user session with decrypted meeting data
                    try {
                        yield onMSLogin(msUserProfile, decryptedMeetingData, tenantId);
                        setStatus("Login successful! Redirecting to meeting...");
                        // Build redirect URL with link parameter (reuse the already extracted linkParam)
                        const redirectUrl = linkParam
                            ? `${MEETING_ROUTES.JOIN_MEETING_HM}?link=${encodeURIComponent(linkParam)}`
                            : MEETING_ROUTES.JOIN_MEETING_HM;
                        console.log("redirectUrl in handlerCallback:", redirectUrl);
                        setTimeout(() => {
                            navigate(redirectUrl);
                        }, 1000);
                    }
                    catch (loginError) {
                        // If user login fails, still allow meeting access with MS token
                        console.error("User login failed, but continuing with meeting:", loginError);
                        setStatus("Redirecting to meeting...");
                        // Build redirect URL with link parameter (reuse the already extracted linkParam)
                        const redirectUrl = linkParam
                            ? `${MEETING_ROUTES.JOIN_MEETING_HM}?link=${encodeURIComponent(linkParam)}`
                            : MEETING_ROUTES.JOIN_MEETING_HM;
                        setTimeout(() => {
                            navigate(redirectUrl);
                        }, 1000);
                    }
                }
                else {
                    setError("Failed to exchange code for token");
                }
            }
            catch (err) {
                console.error("Error handling callback:", err);
                setError(((_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
                    (err === null || err === void 0 ? void 0 : err.message) ||
                    "Failed to complete login");
            }
        });
        handleCallback();
    }, [searchParams, navigate]);
    const spinnerIndicator = (_jsx(LoadingOutlined, { style: { fontSize: 48, color: "#1890ff" }, spin: true }));
    if (error) {
        return (_jsxs("div", Object.assign({ style: {
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            } }, { children: [_jsx("div", Object.assign({ style: { color: "red", marginBottom: 16 } }, { children: error })), _jsx("button", Object.assign({ onClick: () => navigate(-1) }, { children: "Go Back" }))] })));
    }
    return (_jsxs("div", Object.assign({ style: {
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        } }, { children: [_jsx(Spin, { size: "large", indicator: spinnerIndicator }), _jsx("div", Object.assign({ style: { marginTop: 16 } }, { children: status }))] })));
};
export default ManagerMsLoginCallback;
